__turbopack_context__.v({
  "round": "toggle-module-scss-module__6HGaLq__round",
  "slider": "toggle-module-scss-module__6HGaLq__slider",
  "switch": "toggle-module-scss-module__6HGaLq__switch",
  "wrp": "toggle-module-scss-module__6HGaLq__wrp",
});
